import 'core-js/client/shim';
import 'reflect-metadata';
import 'core-js/es6';
import 'core-js/es7/reflect';

require('zone.js/dist/zone');


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/polyfills.ts
 **/